"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactBigCalendar = require("react-big-calendar");

var _generateColor = require("../utils/generateColor");

var _CustomToolbar = _interopRequireDefault(require("./CustomToolbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var localizer = (0, _reactBigCalendar.momentLocalizer)(_moment["default"]);

function CalendarView(_ref) {
  var events = _ref.events,
      startAccessor = _ref.startAccessor,
      endAccessor = _ref.endAccessor,
      onSelectEvent = _ref.onSelectEvent,
      onSelectSlot = _ref.onSelectSlot,
      onRangeChange = _ref.onRangeChange;

  // Custom style event calendar
  var eventStyleGetter = function eventStyleGetter(event) {
    var bgColor = (0, _generateColor.generateColor)(event.title);
    var style = {
      backgroundColor: bgColor,
      display: "flex",
      alignItem: "center",
      color: "white",
      borderRadius: 4,
      height: 23,
      paddingTop: 2,
      fontSize: 13
    };
    return {
      style: style
    };
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: "100%",
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactBigCalendar.Calendar, {
    selectable: true,
    localizer: localizer,
    events: events,
    startAccessor: startAccessor,
    endAccessor: endAccessor,
    defaultView: "month",
    eventPropGetter: eventStyleGetter,
    onSelectSlot: onSelectSlot,
    components: {
      toolbar: _CustomToolbar["default"]
    },
    formats: {
      timeGutterFormat: "HH:ss",
      dayFormat: "dddd, D"
    },
    onSelectEvent: onSelectEvent,
    onRangeChange: onRangeChange
  }));
}

CalendarView.propTypes = {
  events: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    title: _propTypes["default"].string,
    start: _propTypes["default"].instanceOf(Date),
    end: _propTypes["default"].instanceOf(Date)
  })),
  startAccessor: _propTypes["default"].string,
  endAccessor: _propTypes["default"].string,
  onSelectEvent: _propTypes["default"].func,
  onSelectSlot: _propTypes["default"].func,
  onRangeChange: _propTypes["default"].func
};
CalendarView.defaultProps = {
  startAccessor: "start",
  endAccessor: "end",
  events: []
};
var _default = CalendarView;
exports["default"] = _default;